import { createFileRoute } from '@tanstack/react-router';

import { PinterestSettingsPage } from '@/features/social';
import { storeQueryOptions } from '@/features/stores';

/** Readable with `social.read`; saving goes through the store PATCH and needs `settings.write`. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/social/pinterest/settings')({
  staticData: { crumb: 'social:nav.settings' },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...storeQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: PinterestSettingsPage,
});
